const Payment = {

    // FIELDS
    "search": "Search",
    "premise": "Premise",
    "unit": "Unit",
    "month": "Month",
    "financial_year": "Financial Year",
    "warn_select_premise": "Please select a premise before searching units.",

    // PAGE HEADER
    "payments": "Payments",

    // TABLE HEADERS
    "table_premise": "PREMISE",
    "table_unit": "UNIT",
    "table_resident": "RESIDENT",
    "table_due_amount": "DUE AMOUNT",

    // BILLING DETAILS
    "billing_total_amount": "Total Amount",
    "billing_paid_amount": "Paid Amount",
    "billing_due_amount": "Due Amount",
    "billing_discount_amount": "Discount Amount",
    "billing_penalty_amount": "Penalty Amount",
    "billing_fine_amount": "Fine Amount",
    "payment_details": "Payment Details",
    "monthly_payment_details": "Monthly Payment Details",
    "overall_payment_details": "Overall Payment Details",
    "load_error": "Unable to load payment details. Please try again.",

    // SECTIONS
    "transactions": "Transactions",
    "payment_history": "Payment History",
    "discount_rule": "Discount Rule",
    "penalty_rule": "Penalty Rule",
    "no_transactions": "No transactions found.",
    "no_payment_history": "No payment history found.",

    // TRANSACTION TABLE HEADERS
    "charge_type": "Charge Type",
    "description": "Description",
    "invoice_date": "Date",
    "due_date": "Due Date",
    "sub_total": "Sub Total",
    "tax_amount": "Tax",
    "discount": "Discount",
    "penalty": "Penalty",
    "paid_amount": "Paid",
    "due_amount": "Due",
    "transaction_status": "Transaction Status",
    "view_invoice": "View",

    // PAYMENT HISTORY TABLE HEADERS
    "transaction_no": "Transaction No",
    "gateway_payment_id": "Gateway Payment ID",
    "payment_amount": "Amount",
    "payment_date": "Payment Date",
    "remarks": "Remarks",
    "payment_status": "Payment Status",
    "paid_by": "Paid By",

    // ONLINE PAYMENT
    "online_payment": "Online Payment",
    "amount_to_pay": "Amount to Pay",
    "pay_now": "Pay Now",
    "error_amount": "Enter amount",
    "error_amount_positive": "Amount must be greater than zero",
    "error_amount_exceeds_due": "Amount cannot be greater than the due amount",
    "error_gateway_not_configured": "Payment gateway is not configured for this premise.",
    "error_gateway_inactive": "Payment gateway is not active for this premise.",
    "gateway_coming_soon": "This payment gateway will be available in a future release.",
    "gateway_not_supported": "The configured payment gateway is not supported.",
    "payment_initiating": "Initiating payment...",
    "payment_success": "Payment completed successfully.",
    "payment_failed": "Payment failed. Please try again.",
    "payment_cancelled": "Payment was cancelled.",
    "payment_description": "Unit payment",

    // OFFLINE PAYMENT
    "offline_payment": "Offline Payment",
    "add_offline_payment": "Record Offline Payment",
    "mode_of_payment": "Mode of Payment",
    "transaction_id_reference": "Transaction ID / Reference Number",
    "payment_date": "Payment Date",
    "amount": "Amount",
    "description_notes": "Description / Notes",

    // MODE OF PAYMENT OPTIONS
    "payment_mode_cash": "Cash",
    "payment_mode_cheque": "Cheque",
    "payment_mode_online_transfer": "Online Transfer",
    "payment_mode_upi": "UPI",
    "payment_mode_bank_transfer": "Bank Transfer",
    "payment_mode_demand_draft": "Demand Draft",
    "payment_mode_other": "Other",

    // OFFLINE VALIDATION
    "error_payment_mode": "Select Mode of Payment",
    "error_transaction_id_required": "Enter Transaction ID / Reference Number",
    "error_payment_date_required": "Select Payment Date",
    "error_payment_date_future": "Payment date cannot be a future date",

    "offline_payment_success": "Offline payment recorded successfully.",
    "select_unit_to_view_details": "Select a unit to view payment details.",
    "no_due_amount": "No due amount for this unit.",
    "offline_payment_permission_denied": "You do not have permission to record offline payments.",

    "send_reminder": "Send reminder",
    "reminder_type": "Reminder type",
    "reminder_notification": "Notification",
    "reminder_email": "Email",
    "reminder_remark": "Remark",
    "reminder_sent_success": "Reminder sent successfully.",
}

export default Payment;